module.exports = __webpack_public_path__ + "static/media/Mapa-Maranhão.0b51585d.svg";